import { render, staticRenderFns } from "./tempSelfSignRecord.vue?vue&type=template&id=f2c08662&scoped=true"
import script from "./tempSelfSignRecord.vue?vue&type=script&lang=js"
export * from "./tempSelfSignRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c08662",
  null
  
)

export default component.exports